import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_circle"}/>
}
